import { fromEvent, map } from 'rxjs';

export const isMobile$ = fromEvent<Event>(window, 'resize').pipe(
  map((res: any) => res.target.innerWidth < 1024)
);
